import React from "react";

import {UiState} from "../../ui-state";
import {AppState} from "../../../stores/app-mobx";

import "./tools.scss";
import {ElevationProfileButton} from "./elevation-profile/elevation-profile-button";
import {MeasurementButtons} from "./measurement/measurement-buttons";
import {ToolsConfiguration} from "../../config/tools-configuration";



interface ToolsProps {
    config: ToolsConfiguration;
    view: __esri.MapView | __esri.SceneView | undefined;
    uiStore: UiState;
    appStore: AppState;
    small?: boolean;
}

export class Tools extends React.Component<ToolsProps, any> {
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    widgetKey = "tools";
    constructor(props: ToolsProps) {
        super(props);
        this.state = {
            viewModel: null,
            isLoading: true,
            activeTool: null
        };
        if (typeof this.props.small === "boolean" && this.props.small) {
            this.widgetKey += "-small";
        }
        this.handleClick=this.handleClick.bind(this);
    }
    handleClick(tool: string | null, subTool?: string): void {
        const {uiStore, appStore} = this.props;
        this.setState({activeTool: tool});
        if (tool) {
            uiStore.PopupStore.setDisabled(true);
            appStore.projectSelectingEnabled = false;
            uiStore.setActiveTool(tool + ((subTool !== undefined)? "-"+subTool: ""));
        } else {
            uiStore.PopupStore.setDisabled(false);
            appStore.projectSelectingEnabled = true;
            uiStore.setActiveTool("");
        }
    }
    componentDidMount(): void {
    }

    componentWillUnmount(): void {
        const {uiStore} = this.props;
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
        uiStore.removeWidget(this.widgetKey);
    }

    render(): JSX.Element | null {
        const {small, uiStore} = this.props;
        const {activeTool} = this.state;
        return (
            <div className={"geo-tools-wrapper"}>
                <MeasurementButtons
                    active={activeTool==="measurement"}
                    uiStore={uiStore}
                    onClick={this.handleClick}
                    small={small}/>
                <ElevationProfileButton
                    active={activeTool==="profile"}
                    uiStore={uiStore}
                    onClick={this.handleClick}
                    small={small}/>
            </div>
        );
    }
}
